import styled, { breakpoints, css, Device, Scale, StyledComponent } from '@se-admin/falcon';

const STANDARD_TILE_WIDTH: string = '75%';
const TABLET_TILE_WIDTH: string = '30%';
const DESKTOP_TILE_WIDTH: string = `calc(25% - ${Scale.m});`;

export const WrappedSaleCard: StyledComponent<'div', {}, {}> = styled('div')(() => {
  return css`
    display: flex;
    flex-shrink: 0;
    vertical-align: top;
    white-space: normal;
    width: ${STANDARD_TILE_WIDTH};

    &:not(:first-child) {
      margin-left: ${Scale.m};
    }

    @media (min-width: ${breakpoints[Device.tablet]}) {
      width: ${TABLET_TILE_WIDTH};
    }

    @media (min-width: ${breakpoints[Device.desktop]}) {
      width: ${DESKTOP_TILE_WIDTH};
    }
  `;
});
